module.exports = __webpack_public_path__ + "img/xu-b16x100.prt.522bed0d.jpg";